import { useCallback, useEffect, useRef, useState } from 'react'
import { Button } from '@cargomart/ui'
import { useTypedSelector } from 'hooks'

const CLOSE_DELAY = 5 * 60 * 1000

const VersionChecker = () => {
  const [isShow, setIsShow] = useState(false)
  const { clientVersion, serverVersion } = useTypedSelector((state) => state.version)
  const initialLoad = useRef(true)

  const handleConfirm = useCallback(() => {
    window.location.reload()
  }, [])

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>

    if (!initialLoad.current && clientVersion && serverVersion !== clientVersion) {
      setIsShow(true)
      timer = setTimeout(handleConfirm, CLOSE_DELAY)
    }

    initialLoad.current = false

    return () => clearTimeout(timer)
  }, [clientVersion, handleConfirm, serverVersion])

  return isShow ? (
    <div
      className="fixed bottom-1 z-notice flex w-full p-1 text-inverse-on-surface md:bottom-4 md:justify-center md:p-0"
      data-test="notification"
      data-test-id="version--banner"
    >
      <div className="flex w-[260px] flex-col items-center gap-4 rounded-lg bg-inverse-surface p-2 md:w-max md:flex-row">
        <div className="pr-10">Выпущена новая версия сайта. Мы обновим страницу принудительно в ближайшие 5 минут.</div>
        <div className="w-full md:w-max">
          <Button className="w-full" onClick={handleConfirm} size="nm" variant="solid">
            Обновить сейчас
          </Button>
        </div>
      </div>
    </div>
  ) : null
}

export default VersionChecker
